import '../css/app.css';

import { createInertiaApp } from '@inertiajs/react';
import axios from 'axios';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initializeTheme } from './hooks/use-appearance';

// Configure axios for Laravel CSRF
axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['Accept'] = 'application/json';

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';
const pageModules = import.meta.glob([
    './pages/**/*.tsx',
    '!./pages/**/*.test.tsx',
    '!./pages/**/__tests__/**',
]);

createInertiaApp({
    title: (title) => (title ? `${title} - ${appName}` : appName),
    resolve: (name) => resolvePageComponent(`./pages/${name}.tsx`, pageModules),
    setup({ el, App, props }) {
        const root = createRoot(el);

        root.render(
            <StrictMode>
                <App {...props} />
            </StrictMode>,
        );
    },
    progress: {
        color: '#4B5563',
    },
});

// This will set light / dark mode on load...
initializeTheme();

// Initialize OpenReplay session tracking (browser + production only).
// Lazily imported so it never enters the SSR bundle.
if (import.meta.env.PROD && typeof window !== 'undefined') {
    const projectKey = import.meta.env.VITE_OPENREPLAY_PROJECT_KEY;

    if (projectKey) {
        void import('@openreplay/tracker').then(({ default: Tracker }) => {
            const tracker = new Tracker({ projectKey });
            tracker.start();
        });
    }
}
